<template>
  <div class="orderGoods">
    <div class="total">共{{ cartInfo.length }}件商品
		<span v-if="orderInfo.is_judge === 1 && orderInfo.judge_status == 4" style="margin-left: 40%;">
			<a :href="orderInfo.rpUrl" class="bnt bg-color-red" style="color:#fff;text-align: center;padding: 2% 4%;">查看并下载处方</a>
		</span>
	</div>
    <div class="goodWrapper">
      <div
        class="item acea-row row-between-wrapper"
        v-for="cart in cartInfo"
        :key="cart.id"
      >
        <div class="pictrue">
          <img :src="cart.productInfo.image" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">{{ cart.productInfo.store_name }}</div>
            <div class="num">x {{ cart.cart_num }}</div>
          </div>
          <div class="attr line1" v-if="cart.productInfo.attrInfo">
            {{ cart.productInfo.attrInfo.suk }}
          </div>
          <div class="money font-color-red">￥{{ cart.truePrice }}</div>
          <div class="cjbtn">
            <div
              class="evaluate"
              v-if="evaluate === 3"
              @click="$router.push({ path: '/goods_evaluate/' + cart.unique })"
            >
              评价
            </div>
            <!--      <div
              v-if="evaluate === 1"
              class="evaluate"
              @click="
                $router.push({
                  path: '/recede/refundmoney',
                  query: {
                    oid: oid,
                    product_id: cart.productInfo.id,
                    pay_price: cart.cart_num*cart.truePrice
                  }
                })
              "
            >
              退款
            </div> -->
            <div
              v-if="evaluate === 2 && cart.is_apply == ''"
              class="evaluate"
              @click="
                $router.push({
                  path: '/recede/refund',
                  query: {
                    oid: oid,
                    product_id: cart.productInfo.id,
                    pay_price: cart.cart_num * cart.truePrice,
                    id: cart.is_apply.id
                  }
                })
              "
            >
              退换货
            </div>
            <div
              v-if="evaluate === 2 && cart.is_apply != ''"
              class="evaluate"
              @click="
                $router.push({
                  path: '/recede/recededetails',
                  query: {
                    id: cart.is_apply.id
                  }
                })
              "
            >
              退换货信息
            </div>
            <div
              v-if="recedetype == 1 && applytype == 0"
              class="evaluate"
              @click="
                $router.push({
                  path: '/recede/refundmoneyinfo',
                  query: {
                    id: id
                  }
                })
              "
            >
              物流信息
            </div>

            <div
              v-if="recedetype == 1 && applytype == 1"
              class="evaluate"
              @click="
                $router.push({
                  path: '/recede/exchangeinfo',
                  query: {
                    id: id
                  }
                })
              "
            >
              物流信息
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderGoods",
  props: {
    evaluate: Number,
	orderInfo: {
      type: Array,
      default: () => []
    },
    cartInfo: {
      type: Array,
      default: () => []
    },
    oid: {
      type: Number,
      default: () => []
    },
    recedetype: Number,
    applytype: Number,
    id: Number
  },
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {}
};
</script>
<style>
.cjbtn {
  width: 100%;
  height: 20px;
}
.goodWrapper .item .text .evaluate {
  width: auto;
  height: 0.46rem;
  border: 1px solid #e93323;
  color: #e93323;
  border-radius: 0.04rem;
  text-align: center;
  line-height: 0.46rem;
  right: 0;
  bottom: -0.1rem;
  float: right;
  margin: 0 8px;
  padding: 0 3px;
}
</style>
